import React, { Component, Suspense } from 'react';
import { Card, CardBody } from 'reactstrap';
import ContentWrapper from '../../template/Layout/ContentWrapper';
// import StandardReports from '../Components/Reports/StandardReports';
import { connect } from 'react-redux';
import { Tab } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

const StandardReports = React.lazy(() => import('./StandardReports'));
const MyReports = React.lazy(() => import('./MyReports/List'));
const SharedReports = React.lazy(() => import('./SharedReports'));

class Reportes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 0
    }
  }

  componentDidMount = () => {

  }

  onChangeTab = (e, val) => {
    let { currentTab } = this.state;
    if (currentTab !== val.activeIndex) {
      currentTab = val.activeIndex;
      document.getElementById("regresar-div").innerHTML = "";
    }
    this.setState({ currentTab });

  }


  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    return (
      <ContentWrapper>
        <div className="content-heading">
          {/* <Row> */}
          <legend className="legendBasic">
            <i className='demo-icon icon-10abr23-iconosmagicdome-04_'></i>
            {/* <img
              style={{ margin: '-6px 6px 1px' }}
              alt=""
              src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_reportes.svg"
              height="28"
              width="28"
            ></img> */}
            {this.props.t("my_reports")}
          </legend>
          {
            <div id="regresar-div" ></div>
          }
          {/* </Row> */}
        </div>
        <Card className="myCard">
          <CardBody>
            <Tab
              menu={{ secondary: true, className: "wrapped", pointing: true, style: { fontSize: "14px" } }}
              onTabChange={this.onChangeTab}
              //       // activeIndex={tabIndex}
              menuPosition="right"
              panes={[{
                menuItem: this.props.t("standard_reports"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {' '}
                    <StandardReports type="Standard" user={this.props._user} />
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("my_reports"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {' '}
                    <MyReports type="MyReports" user={this.props._user} />
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("shared_reports"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {' '}
                    <SharedReports type="SharedReports" user={this.props._user} />
                  </Suspense>
                ),
              },]}
            />
          </CardBody>
        </Card>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(Reportes)));